import { FC } from "react"
import { IconProps } from "@/components/shared/Icon"

const LowerThresholdIcon: FC<IconProps> = ({ ...props }) => {
   return (
      <svg
         viewBox="0 0 24 24"
         fill="none"
         {...props}
      >
         <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M17.7614 17.3673L12.5761 22.7522C12.2579 23.0826 11.7421 23.0826 11.4239 22.7522L6.23864 17.3673C5.92045 17.0368 5.92045 16.5011 6.23864 16.1706C6.55683 15.8402 7.07273 15.8402 7.39092 16.1706L11.1852 20.111L11.1852 1.84615C11.1852 1.37884 11.55 0.999999 12 0.999999C12.45 0.999999 12.8148 1.37884 12.8148 1.84615L12.8148 20.1111L16.6091 16.1706C16.9273 15.8402 17.4432 15.8402 17.7614 16.1706C18.0795 16.5011 18.0795 17.0368 17.7614 17.3673Z"
            fill="currentColor"
         />
         <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M18.1215 15.8238C18.6262 16.3479 18.6262 17.19 18.1215 17.7141L12.9363 23.099C12.4214 23.6337 11.5786 23.6337 11.0637 23.099L5.87848 17.7141C5.37384 17.19 5.37384 16.3479 5.87848 15.8238C6.39334 15.2891 7.23622 15.2891 7.75108 15.8238L10.6852 18.8709L10.6852 1.84615C10.6852 1.12067 11.2562 0.499999 12 0.499999C12.7438 0.499999 13.3148 1.12067 13.3148 1.84615L13.3148 18.8709L16.2489 15.8238C16.7638 15.2891 17.6067 15.2891 18.1215 15.8238ZM17.4012 17.0205C17.5329 16.8836 17.5329 16.6543 17.4012 16.5174C17.2797 16.3913 17.0908 16.3913 16.9693 16.5174L12.3148 21.3512L12.3148 1.84615C12.3148 1.637 12.1562 1.5 12 1.5C11.8438 1.5 11.6852 1.637 11.6852 1.84615L11.6852 21.3512L7.03075 16.5174C6.90923 16.3913 6.72033 16.3913 6.59881 16.5174C6.46706 16.6543 6.46706 16.8836 6.59881 17.0205L11.784 22.4054C11.9055 22.5315 12.0945 22.5315 12.216 22.4054L17.4012 17.0205Z"
            fill="currentColor"
         />
      </svg>
   )
}

export default LowerThresholdIcon
